function init() {
    InitCtaGrid();
}

function InitCtaGrid() {
    $(function () {
        $('.content-cta-grid').find('.six-grid-layout__box:odd').addClass('u-bg-color-off-white');
    });
}
export {
    init
}